(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nordal-cart-drawer"] && !Shopify.designMode) return;
  try {
    /* Shopify bundelt alle snippet-JS tot compiled_assets/snippet-scripts.js en
     hercompileert dat niet altijd bij een themapush. Deze marker verandert mee
     met de inhoud, zodat de bundle gegarandeerd een nieuwe hash krijgt. */
  /* build: cart-drawer upsells altijd zichtbaar */
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var itemsEl = drawer.querySelector('[data-cart-drawer-items]');
    var emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
    var footerEl = drawer.querySelector('[data-cart-drawer-footer]');
    var totalEl = drawer.querySelector('[data-cart-drawer-total]');
    var totalWasEl = drawer.querySelector('[data-cart-drawer-total-was]');
    var countEl = drawer.querySelector('[data-cart-drawer-count]');
    var checkoutEl = drawer.querySelector('[data-cart-drawer-checkout]');
    var discountsEl = drawer.querySelector('[data-cart-drawer-discounts]');
    var shippingEl = drawer.querySelector('[data-cart-drawer-shipping]');
    var shippingMsgEl = drawer.querySelector('[data-cart-drawer-shipping-msg]');
    var shippingFillEl = drawer.querySelector('[data-cart-drawer-shipping-fill]');
    var recEl = drawer.querySelector('[data-cart-drawer-rec]');
    var recTrackEl = drawer.querySelector('[data-cart-drawer-rec-track]');
    var lastRecKey = null;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var tagIcon = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 12.5 12.5 20 4 11.5V4h7.5z"/><circle cx="8" cy="8" r="1.3" fill="currentColor" stroke="none"/></svg>';

    var plusIcon = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>';

    var i18n = {};
    try {
      var i18nEl = drawer.querySelector('[data-cart-drawer-i18n]');
      if (i18nEl) i18n = JSON.parse(i18nEl.textContent) || {};
    } catch (e) { i18n = {}; }
    var entityDecoder = document.createElement('textarea');
    function tr(key, amount) {
      entityDecoder.innerHTML = i18n[key] || '';
      var str = entityDecoder.value;
      return amount != null ? str.replace('[amount]', function () { return amount; }) : str;
    }
    function escAttr(str) {
      return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }

    /* Alle bedragen uit /cart.js en de recommendations-API staan al in centen in de
       presentment-valuta; het format komt van de winkel (bv. "€" + amount_with_comma_separator). */
    var moneyFormat = i18n.moneyFormat || '€{' + '{amount_with_comma_separator}}';
    function money(cents) {
      var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!match) return moneyFormat;
      function group(decimals, thousands, decimal) {
        var parts = (Math.round(cents) / 100).toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
      }
      var value;
      switch (match[1]) {
        case 'amount_no_decimals': value = group(0, ',', '.'); break;
        case 'amount_with_comma_separator': value = group(2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = group(0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = group(2, "'", '.'); break;
        case 'amount_with_space_separator': value = group(2, ' ', ','); break;
        default: value = group(2, ',', '.');
      }
      return moneyFormat.replace(match[0], value);
    }


    // De aanbevelingen voegen direct toe aan het mandje; de klant blijft in de
    // afrekenflow in plaats van naar de PDP te springen. 250ml is de maat die de
    // rest van de site ook voorstelt, met de eerste beschikbare maat als terugval.
    function pickVariant(product) {
      var vs = (product && product.variants) || [];
      var fallback = null;
      for (var i = 0; i < vs.length; i++) {
        if (vs[i].available === false) continue;
        if (String(vs[i].title || '').indexOf('250') !== -1) return vs[i];
        if (!fallback) fallback = vs[i];
      }
      return fallback;
    }

    function addVariant(id) {
      return fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).then(function (r) { return r.json(); });
    }

    function render(cart) {
      if (cart) syncCountBubble(cart);
      itemsEl.innerHTML = '';

      if (!cart || !cart.items || !cart.items.length) {
        emptyEl.hidden = false;
        footerEl.hidden = true;
        countEl.hidden = true;
        if (shippingEl) shippingEl.hidden = true;
        if (recEl) recEl.hidden = true;
        return;
      }

      emptyEl.hidden = true;
      footerEl.hidden = false;
      countEl.hidden = false;
      countEl.textContent = cart.item_count;
      checkoutEl.href = rootUrl + 'checkout';

      // De compactere itemweergave blijft aan bij meerdere producten, maar de
      // "Aanbevolen voor jou"-carousel tonen we altijd: producten die al in de
      // mand zitten worden er in loadRecommendations sowieso uitgefilterd.
      drawer.classList.toggle('has-multiple-items', cart.items.length > 1);
      loadRecommendations(cart);

      if (shippingEl && shippingFillEl && shippingMsgEl) {
        var threshold = parseInt(shippingEl.getAttribute('data-threshold'), 10) || 0;
        if (threshold > 0) {
          shippingEl.hidden = false;
          var remaining = threshold - cart.total_price;
          var pct = Math.min(100, Math.max(0, (cart.total_price / threshold) * 100));
          shippingFillEl.style.width = pct + '%';
          shippingMsgEl.textContent = remaining > 0
            ? tr('shippingRemaining', money(remaining))
            : tr('shippingUnlocked');
        }
      }

      var originalTotal = cart.items.reduce(function (sum, item) { return sum + (item.original_line_price || item.line_price); }, 0);
      var finalTotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
      totalEl.textContent = money(finalTotal);
      if (originalTotal > finalTotal) {
        totalWasEl.hidden = false;
        totalWasEl.textContent = money(originalTotal);
      } else {
        totalWasEl.hidden = true;
      }

      if (cart.total_discount > 0) {
        discountsEl.hidden = false;
        discountsEl.innerHTML = '<li>' + tagIcon + ' ' + tr('discountApplied', money(cart.total_discount)) + '</li>';
      } else {
        discountsEl.hidden = true;
        discountsEl.innerHTML = '';
      }

      cart.items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'cart-drawer-item';
        var hasLineDiscount = item.original_line_price > item.final_line_price;
        li.innerHTML =
          '<div class="cart-drawer-item-media">' +
            (item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="88" height="104">' : '') +
          '</div>' +
          '<div class="cart-drawer-item-info">' +
            '<div class="cart-drawer-item-top">' +
              '<span class="cart-drawer-item-title">' + item.product_title + '</span>' +
              '<span class="cart-drawer-item-qty" data-key="' + item.key + '">' +
                '<button type="button" data-qty-minus aria-label="' + escAttr(tr('decrease')) + '">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty-plus aria-label="' + escAttr(tr('increase')) + '">+</button>' +
              '</span>' +
            '</div>' +
            (item.variant_title ? '<div class="cart-drawer-item-variant">' + item.variant_title + '</div>' : '') +
            '<span class="cart-drawer-item-price">' +
              (hasLineDiscount ? '<s>' + money(item.original_line_price) + '</s>' : '') +
              money(item.final_line_price) +
            '</span>' +
          '</div>';
        itemsEl.appendChild(li);
      });
    }

    function fetchCart() {
      return fetch(rootUrl + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(function (r) { return r.json(); });
    }

    function refresh() {
      return fetchCart().then(render).catch(function () {});
    }

    function syncCountBubble(cart) {
      var bubble = document.querySelector('[data-cart-count]');
      if (bubble) {
        bubble.textContent = cart.item_count;
        bubble.hidden = cart.item_count === 0;
      }
    }

    function changeQty(key, quantity) {
      return fetch(rootUrl + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        render(cart);
      });
    }

    if (recTrackEl) {
      recTrackEl.addEventListener('click', function (e) {
        var card = e.target.closest('[data-rec-add]');
        if (!card || card.disabled) return;
        var id = card.getAttribute('data-variant-id');
        if (!id) return;
        card.disabled = true;
        card.classList.add('is-adding');
        addVariant(id).then(function () {
          return refresh();
        }).catch(function () {
          card.disabled = false;
          card.classList.remove('is-adding');
        });
      });
    }

    itemsEl.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (minus || plus) {
        var wrap = e.target.closest('[data-key]');
        var key = wrap.getAttribute('data-key');
        var current = parseInt(wrap.querySelector('span').textContent, 10) || 1;
        var next = minus ? Math.max(0, current - 1) : current + 1;
        changeQty(key, next);
      }
    });

    // Shopify's eigen "related products"-endpoint, gevoed door het eerste item in
    // het mandje - geen handmatige merchant-curatie nodig en werkt meteen mee met
    // wat er daadwerkelijk in het mandje ligt. Producten die al in het mandje zitten
    // worden eruit gefilterd. De cache-sleutel is de volledige set product-id's in
    // het mandje, niet alleen het eerste artikel: legt de klant er een tweede
    // product bij, dan moet de lijst opnieuw filteren zodat dat artikel niet
    // alsnog in de carousel blijft staan. Een qty-wijziging van hetzelfde artikel
    // laat de sleutel ongemoeid en haalt dus niets opnieuw op.
    function loadRecommendations(cart) {
      if (!recEl || !recTrackEl) return;
      var firstId = cart.items[0].product_id;
      var key = cart.items.map(function (item) { return item.product_id; }).join(',');
      if (key === lastRecKey) return;
      lastRecKey = key;

      fetch(rootUrl + 'recommendations/products.json?product_id=' + firstId + '&limit=10&intent=related', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (r) { return r.json(); }).then(function (data) {
        var products = (data && data.products) || [];
        var inCartIds = cart.items.map(function (item) { return item.product_id; });
        var filtered = products.filter(function (p) { return inCartIds.indexOf(p.id) === -1; }).slice(0, 8);

        if (!filtered.length) { recEl.hidden = true; return; }
        recEl.hidden = false;
        recTrackEl.innerHTML = filtered.map(function (p) {
          // Dezelfde bron als de rest van de site (nordal-product-card): de foto van
          // de eerste variant, niet product.featured_image - dat laatste is bij deze
          // producten toevallig de blauwe lifestyle-foto, niet de normale packshot.
          var variantImg = p.variants && p.variants[0] && p.variants[0].featured_image && p.variants[0].featured_image.src;
          var rawImg = variantImg || p.featured_image;
          var img = rawImg ? rawImg.replace(/\.(jpg|jpeg|png|webp)(\?|$)/i, '_260x.$1$2') : '';
          var v = pickVariant(p);
          if (!v) return '';
          return (
            '<button type="button" class="cart-drawer-rec-card" data-rec-add data-variant-id="' + v.id + '">' +
              '<span class="cart-drawer-rec-media">' +
                (img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" width="130" height="130">' : '') +
                '<span class="cart-drawer-rec-plus" aria-hidden="true">' + plusIcon + '</span>' +
              '</span>' +
              '<span class="cart-drawer-rec-title">' + p.title + '</span>' +
              '<span class="cart-drawer-rec-price">' + money(v.price != null ? v.price : p.price) + '</span>' +
            '</button>'
          );
        }).join('');
      }).catch(function () { recEl.hidden = true; });
    }

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('nordal-cart-lock');
      refresh();
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('nordal-cart-lock');
    }

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    window.NordalCartDrawer = { open: open, close: close, refresh: refresh };

    document.querySelectorAll('[data-cart-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    document.addEventListener('nordal:cart:added', function () { open(); });

    // Iemand kwam net van /cart en is teruggestuurd naar deze pagina (zie
    // sections/nordal-cart.liquid): open de drawer meteen zodat de inhoud van het
    // mandje alsnog zichtbaar is, i.p.v. dat het bezoek "verdwijnt".
    try {
      if (sessionStorage.getItem('nordal:openCartDrawer') === '1') {
        sessionStorage.removeItem('nordal:openCartDrawer');
        open();
      }
    } catch (e) {}
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nordal-exit-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var popup = document.querySelector('[data-exit-popup]');
    if (!popup) return;

    var STORAGE_KEY = 'nordal-exit-popup-seen';
    var SCROLL_THRESHOLD = 0.75;
    var TIME_THRESHOLD_MS = 60000;
    // Exit-intent telt pas na deze verblijftijd: wie direct na het laden naar de
    // adresbalk beweegt, heeft nog niets gezien en krijgt anders meteen de pop-up.
    var EXIT_INTENT_MIN_MS = 20000;
    var loadedAt = Date.now();

    // Al gezien (dit toevoegen/afmelden of eerder gesloten) -> nooit meer tonen in
    // deze browser. try/catch: localStorage kan geblokkeerd zijn (privacymodus).
    var alreadySeen = false;
    try { alreadySeen = localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}
    if (alreadySeen) return;

    var shown = false;
    var timers = [];

    function markSeen() {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }

    function open() {
      if (shown) return;
      shown = true;
      timers.forEach(function (t) { clearTimeout(t); });
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseleave', onExitIntent);
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      markSeen();
    }

    function close() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
    }

    function onScroll() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - doc.clientHeight;
      if (scrollable <= 0) return;
      if (window.scrollY / scrollable >= SCROLL_THRESHOLD) open();
    }

    function onExitIntent(e) {
      // Alleen als de muis écht naar boven de viewport uit beweegt (richting de
      // tabbladbalk), niet bij elke mouseleave (bv. naar een ander element).
      if (e.clientY > 0) return;
      if (Date.now() - loadedAt < EXIT_INTENT_MIN_MS) return;
      open();
    }

    popup.querySelectorAll('[data-exit-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    // Als het formulier server-side is teruggekomen (Shopify herlaadt de pagina bij
    // een form-post) met een succes- of foutmelding, meteen open zodat de melding
    // zichtbaar is - niet opnieuw wachten op scroll/tijd/exit-intent.
    if (popup.querySelector('.exit-popup-success') || popup.querySelector('.exit-popup-error')) {
      open();
    } else {
      timers.push(setTimeout(open, TIME_THRESHOLD_MS));
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('mouseleave', onExitIntent);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nordal-product-card"] && !Shopify.designMode) return;
  try {
    // Touch-only: mirror the scroll position of the image track in the dots.
  (function () {
    if (window.matchMedia('(hover: hover)').matches) return;
    document.addEventListener(
      'scroll',
      function (e) {
        var track = e.target.closest ? e.target.closest('[data-pcard-track]') : null;
        if (!track) return;
        var dots = track.parentElement.querySelectorAll('.nordal-pcard__dot');
        if (!dots.length) return;
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
      },
      true
    );
  })();

  (function () {
    function initCard(card) {
      if (card.dataset.pcardInit === 'true') return;
      card.dataset.pcardInit = 'true';

      var sizes = card.querySelectorAll('[data-pcard-size]');
      var idInput = card.querySelector('[data-pcard-id]');
      var priceEl = card.querySelector('[data-pcard-price]');
      var addBtn = card.querySelector('[data-pcard-add]');
      var ctaEl = card.querySelector('[data-pcard-cta]');
      var img = card.querySelector('img.nordal-pcard__img');

      sizes.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizes.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');

          if (idInput) idInput.value = btn.getAttribute('data-variant-id');
          if (priceEl) priceEl.textContent = btn.getAttribute('data-variant-price');

          var vimg = btn.getAttribute('data-variant-image');
          if (img && vimg) { img.srcset = ''; img.src = vimg; }

          var sold = btn.getAttribute('data-variant-soldout') === 'true';
          if (addBtn) {
            addBtn.disabled = sold;
            if (sold) { addBtn.setAttribute('aria-disabled', 'true'); }
            else { addBtn.removeAttribute('aria-disabled'); }
          }
          if (ctaEl && addBtn) ctaEl.textContent = addBtn.getAttribute(sold ? 'data-soldout-label' : 'data-add-label') || ctaEl.textContent;
        });
      });

      function preloadVariants() {
        sizes.forEach(function (b) {
          var u = b.getAttribute('data-variant-image');
          if (u) { var im = new Image(); im.src = u; }
        });
      }
      if ('requestIdleCallback' in window) { requestIdleCallback(preloadVariants); }
      else { setTimeout(preloadVariants, 1200); }

      /* AJAX add-to-cart: zonder dit deed het formulier een gewone POST-submit, wat de
         browser eerst naar een andere pagina liet navigeren voordat de cart drawer
         daar (met het bekende witte-achtergrond-effect) opende. Zelfde patroon als
         nordal-main-product.liquid: /cart/add.js, drawer bijwerken, geen page load. */
      var form = card.querySelector('.nordal-pcard__form');
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return; // laat de normale submit als fallback gebeuren
          e.preventDefault();
          if (addBtn) addBtn.disabled = true;
          var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var idVal = idInput ? idInput.value : form.querySelector('[name="id"]').value;
          fetch(root_url + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(idVal, 10), quantity: 1 }] })
          }).then(function (r) { return r.json(); }).then(function (data) {
            if (addBtn) addBtn.disabled = false;
            if (data && data.status && data.status !== 200) {
              form.submit();
              return;
            }
            document.dispatchEvent(new CustomEvent('nordal:cart:added'));
          }).catch(function () {
            if (addBtn) addBtn.disabled = false;
            form.submit();
          });
        });
      }
    }

    function initCards(scope) {
      (scope || document).querySelectorAll('.nordal-pcard').forEach(initCard);
    }
    function boot() { initCards(document); }
    /* Exposed so dynamically-injected cards (e.g. cross-sell recommendations that replace
       their grid via fetch) can be initialised on just that subtree, without dispatching
       shopify:section:load. Re-running initCard is idempotent via the pcardInit guard. */
    window.nordalInitProductCards = initCards;

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nordal-tokens"] && !Shopify.designMode) return;
  try {
    (function () {
    function start() {
      var els = document.querySelectorAll('.nordal .reveal:not(.in)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < els.length; i++) els[i].classList.add('in');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    }
    if (document.readyState !== 'loading') start();
    else document.addEventListener('DOMContentLoaded', start);
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

})();
